import { outreach } from '@round/api';
import { StringSearchParams, toNumberOrUndefined, useUrlState } from '@round/utils';
import { OutreachRequestsFilterValues } from '../../components/OutreachRequestsFilters/helpers';
import { DEFAULT_ORDERING, parseOrdering } from '../components/OutreachRequestsTable/helpers';

export type UrlState = OutreachRequestsFilterValues & {
    ordering?: string;
};

const parseUrlParams = (searchParams: StringSearchParams<UrlState>): UrlState => ({
    search: searchParams.search,
    status: searchParams.status,
    createdBy: searchParams.createdBy,
    ordering: searchParams.ordering,
});

export const mapToApiParams = (
    urlState: UrlState
): Pick<outreach.GetOutreachRequestsParams, 'search' | 'status' | 'created_by' | 'ordering'> => ({
    search: urlState.search,
    status: urlState.status,
    created_by: toNumberOrUndefined(urlState.createdBy),
    ordering: parseOrdering(urlState.ordering),
});

const initialState: UrlState = {
    ordering: DEFAULT_ORDERING,
};

export function useOutreachRequestsUrlState() {
    const { url, mergeSearchParams } = useUrlState<UrlState>((urlData, { merge }) =>
        merge(urlData, { searchParams: { ...initialState, ...urlData.searchParams } })
    );

    return {
        urlState: parseUrlParams(url.searchParams),
        setUrlState: mergeSearchParams,
    };
}
